import './App.css';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import 'jquery/dist/jquery.slim.min';
import 'popper.js/dist/umd/popper.min';
import { SplashScreen } from '@capacitor/splash-screen';
import { useEffect } from 'react';

import Login from './finance/Login';
import Home from './finance/Home';
import Otp from './finance/Otp';
import Register from './finance/Register';
import Permission from './finance/Permission';
import PanVerifecation from './finance/PanVerifecation';
import Address from './finance/Address';
import Approvedloan from './finance/Approvedloan';
import Employmentdetails from './finance/Employmentdetails';
import Profile from './finance/Profile';
import Reference from './finance/Reference';
import Bankdetail from './finance/BankDetail';
import Approved from './finance/Approved';
import LoanInfo from './finance/LoanInfo';
import LoanDetails from './finance/LoanDetails';
import EmiDetails from './finance/EmiDetails';
import ProductTypes from './finance/ProductTypes';
import DigiSuccess from './finance/DigiSuccess';
import Nominee from './finance/Nominee';
import DocumentUpload from './finance/DocumentUpload';
import VideoUpload from './finance/VideoUpload';
import CustomerList from './finance/CustomerList';
import LoanList from './finance/LoanList';
import CustomerLoanList from './finance/CustomerLoanList';
import RepaymentList from './finance/RepaymentList';
import CreditReport from './finance/CreditReport';
import CreditCheck from './finance/CreditCheck';
import PnbAutoTrigger from './finance/PnbAutoTrigger';
import CustomerEmiPage from './finance/CustomerEmiPage';
import CustomerProfile from './finance/CustomerProfile';

const App = () => {
    useEffect(() => {
        setTimeout(() => {
            SplashScreen.hide({ fadeOutDuration: 500 });
        }, 2500);
    }, []);

    const router = createBrowserRouter([
        { path: "/",                  element: <Login /> },
        { path: "/Home",              element: <Home /> },
        { path: "/Otp",               element: <Otp /> },
        { path: "/Register",          element: <Register /> },
        { path: "/Permission",        element: <Permission /> },
        { path: "/PanVerifecation",   element: <PanVerifecation /> },
        { path: "/Address",           element: <Address /> },
        { path: "/CreditCheck",       element: <CreditCheck /> },
        { path: "/CreditReport",      element: <CreditReport /> },
        { path: "/PnbAutoTrigger",    element: <PnbAutoTrigger /> },
        { path: "/BankDetail",        element: <Bankdetail /> },
        { path: "/Employmentdetails", element: <Employmentdetails /> },
        { path: "/Nominee",           element: <Nominee /> },
        { path: "/Reference",         element: <Reference /> },
        { path: "/DocumentUpload",    element: <DocumentUpload /> },
        { path: "/VideoUpload",       element: <VideoUpload /> },
        { path: "/ProductTypes",      element: <ProductTypes /> },
        { path: "/DigiSuccess",       element: <DigiSuccess /> },
        { path: "/Approvedloan",      element: <Approvedloan /> },
        { path: "/Approved",          element: <Approved /> },
        { path: "/LoanInfo",          element: <LoanInfo /> },
        { path: "/LoanDetails",       element: <LoanDetails /> },
        { path: "/EmiDetails",        element: <EmiDetails /> },
        { path: "/Profile",           element: <Profile /> },
        { path: "/CustomerList",      element: <CustomerList /> },
        { path: "/CustomerLoanList",  element: <CustomerLoanList /> },
        { path: "/CustomerEmiPage",   element: <CustomerEmiPage /> },
        { path: "/CustomerProfile",   element: <CustomerProfile /> },
        { path: "/RepaymentList",     element: <RepaymentList /> },
        { path: "/LoanList",          element: <LoanList /> },
    ]);

    return <RouterProvider router={router} />;
};

export default App;
